export const SET_AUTH_ACCOUNT ='SET_AUTH_ACCOUNT';
export const SET_PROFILE_DATA ='SET_PROFILE_DATA';
export const REMOVE_AUTH_ACCOUNT ='REMOVE_AUTH_ACCOUNT';